import Navbar from "../../component/navbar/Navbar";
import ViewTitle from "../../component/title/view/ViewTitle";
import Title from "../../component/title/Title";
import Text from "../../component/text/Text";
import Footer from "../../component/footer/Footer";
import {useTranslation} from "react-i18next";

export default function NotFoundView() {
    const {t} = useTranslation();

    return <div className={"not-found-view"}>
        <Navbar/>
        <ViewTitle>
            <Title>{t("notFound.title")}</Title>
            <Text>{t("notFound.subtitle")}</Text>
        </ViewTitle>
        <Footer/>
    </div>
}